import React from "react";
import MainLayout from "./MainLayout";
import OnBoardingLegacy from "../common/OnBoarding/OnBoardingLegacy";

const OnBoardingLegacyPage = (props) => <MainLayout component={OnBoardingLegacy} />;

export default OnBoardingLegacyPage;
